"use client";

import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ParentCommandCenter() {
  const {
    ref: contentRef,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  return <section data-section-id="5117" id="parent-command-center" className="relative bg-background text-foreground min-h-screen w-full overflow-hidden">
      {}
      <div className="absolute inset-0 lg:left-[40%]">
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701369/img/youth_tribe_hero.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701369/img/youth_tribe_hero.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701369/img/youth_tribe_hero.png-wvc-sizes" alt="High-energy group of youth laughing and participating in community activities" loading="eager" decoding="async" className="h-full w-full object-cover" />
        {}
        <div className="absolute inset-0 bg-gradient-to-r from-background via-background/80 to-transparent lg:from-background lg:via-background/60 lg:to-transparent" />
        {}
        <div className="absolute top-1/2 left-1/3 h-[60%] w-[40%] -translate-y-1/2 rounded-lg blur-3xl opacity-40 animate-pulse" style={{
        background: "radial-gradient(ellipse, hsl(226 91% 39% / 0.5) 0%, transparent 70%)"
      }} />
      </div>

      {}
      <div className="pointer-events-none absolute inset-0 opacity-[0.08] mix-blend-overlay" style={{
      backgroundImage: "url(\"data:image/svg+xml,%3Csvg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='3'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)'/%3E%3C/svg%3E\")"
    }} />

      {}
      <div className="relative z-10 min-h-screen flex items-center px-6 sm:px-10 lg:px-16 py-24 lg:py-0">
        <div ref={contentRef} className={`w-full lg:w-[55%] max-w-2xl transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          {}
          

          {}
          <h1 className="font-default font-black leading-[0.95] tracking-tighter lowercase text-foreground mb-8 lg:mb-10" style={{
          fontSize: "clamp(3rem, 9vw, 8.5rem)"
        }}>
            <span className="block">building a</span>
            <span className="block">community</span>
            <span className="block">that moves</span>
            <span className="block italic font-default" style={{
            color: "hsl(226 91% 39%)"
          }}>
              together.
            </span>
          </h1>

          {}
          <p className="font-default text-base sm:text-lg max-w-md mb-10 lg:mb-12 leading-relaxed" style={{
          color: "hsl(226 10% 45%)"
        }}>
            Join our dynamic youth group for summer camps, team sports, and weekly social events.
          </p>

          {}
          <div className="flex flex-col sm:flex-row gap-4 sm:gap-6 sm:items-center">
            <Button asChild size="lg" className="bg-primary text-primary-foreground hover:bg-primary/90 rounded-lg font-default text-xs tracking-[0.2em] uppercase h-12 px-7">
              <Link to="/ParentHubPage">
                Download Registration
                <ArrowRight className="ml-1 size-4" />
              </Link>
            </Button>

            <Button asChild variant="ghost" size="lg" className="font-default text-xs tracking-[0.2em] uppercase text-foreground hover:bg-transparent hover:text-primary h-12 px-2 justify-start sm:justify-center group">
              <Link to="/OurRhythmPage">
                <span className="border-b border-foreground/30 group-hover:border-primary pb-1 transition-colors">
                  View Activities
                </span>
              </Link>
            </Button>
          </div>
        </div>
      </div>

      {}
      <div className="hidden lg:flex absolute bottom-12 left-10 z-10 items-center gap-4 -rotate-90 origin-bottom-left">
        <span className="font-default text-[10px] tracking-[0.3em] uppercase whitespace-nowrap" style={{
        color: "hsl(226 10% 45%)"
      }}>
          Scroll ↓ 01 / 07
        </span>
      </div>

      {}
      <div className="hidden md:block absolute top-10 right-10 z-10">
        
      </div>

    </section>;
}